<template>
  <div>
    <h1>Consolidated</h1>

    <div v-if="loading">Loading...</div>

    <div v-if="false">
      {{ breakdown }}
    </div>

    <!-- numbers-->
    <div v-if="!loading">
      <div>showing: {{ filteredList.length }} / {{ items.length }}</div>

      <!-- year -->
      <div>
        Total: {{ total }} <br />
        Ingresos: {{ total_positive }} <br />
        Gastos: {{ total_negative }}
        <div>
          <v-chip-group v-model="year">
            <v-chip :color="year == y ? 'primary' : ''" v-for="y in years" :key="y" :value="y">{{ y }}</v-chip>
          </v-chip-group>
        </div>
      </div>

      <!-- source -->
      <div>
        <div>
          <v-chip-group v-model="source" multiple>
            <v-chip :color="source.includes(s) ? 'primary' : ''" v-for="s in sources" :key="s" :value="s">{{
              s
            }}</v-chip>
          </v-chip-group>
        </div>
      </div>

      <!-- search -->
      <div>
        <v-text-field
          @focus="$event.target.select()"
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          label="Buscar"
          outlined
          v-model="searchText"
          class="mb-1"
        ></v-text-field>
      </div>
    </div>
    <!-- items -->
    <div v-if="!loading">
      <div>
        page: {{ currentPage }}/{{ totalPages }}
        <v-slider :max="totalPages" :min="1" v-model="currentPage"> </v-slider>

        <div v-for="(item, index) in pagedItems" :key="index">
          <MovementListItem :item="item" />
        </div>

        <v-slider :max="totalPages" :min="1" v-model="currentPage"> </v-slider>
        page: {{ currentPage }}
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import utils from '@/assets/utils'
import MovementListItem from './MovementListItem'
export default {
  components: {
    MovementListItem,
  },

  data() {
    return {
      items: [],
      currentPage: 1, // 1-based
      pageSize: 50,
      loading: false,
      year: '',
      //years: [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017],
      //  sources: ['revolut', 'santander', 'edenred'],
      source: [],
      searchText: '',
    }
  },
  watch: {
    currentPage(newValue) {
      if (newValue === 0) this.currentPage = 1 //zero is not an option...
    },
  },
  computed: {
    years() {
      //return array with years since 2017 to current yerar
      const currentYear = new Date().getFullYear()
      const years = []
      for (let y = currentYear; y >= 2017; y--) {
        years.push(y)
      }
      return years
    },
    sources() {
      const s = new Set()
      s.add('revolut')
      s.add('santander')
      s.add('edenred')

      for (let i = 0; i < this.items.length; i++) {
        s.add(this.items[i].source)
      }
      return Array.from(s)
    },
    filteredList() {
      let output = [...this.items]
      if (this.year) {
        output = output.filter((i) => this.year === Number(i.date1.slice(0, 4)))
      }
      if (this.source.length > 0) {
        output = output.filter((i) => this.source.includes(i.source))
      }
      if (this.searchText) {
        output = output.filter((i) => utils.search.searchMatch(this.searchText, [i.text, i.amount].join(' ')))
      }
      return output
    },
    total() {
      const x = [...this.filteredList].reduce((sum, item) => {
        return sum + Number(item.amount)
      }, 0)
      return x.toLocaleString()
    },
    total_negative() {
      const x = [...this.filteredList]
        .filter((f) => Number(f.amount) < 0)
        .reduce((sum, item) => {
          return sum + Number(item.amount)
        }, 0)
      return x.toLocaleString()
    },
    total_positive() {
      const x = [...this.filteredList]
        .filter((f) => Number(f.amount) > 0)
        .reduce((sum, item) => {
          return sum + Number(item.amount)
        }, 0)
      return x.toLocaleString()
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredList.slice(start, end)
    },

    totalPages() {
      return Math.ceil(this.filteredList.length / this.pageSize)
    },
    breakdown() {
      const x = []
      const sample = this.items.slice(0, 10)
      for (let i = 0; i < sample.length; i++) {
        const item = sample[i]
        const y = item.date1.slice(0, 4)
        const m = item.date1.slice(5, 6)

        x.push({ y, m })
      }
      return x
    },
  },
  methods: {
    async fetchData() {
      this.loading = true
      let x = await api.apiFetch('/expenses/merged?type=bank&refresh=0')
      if (!x.ok) return alert('error fetching data')
      const j = await x.json()

      this.items = j.items //bankItems //.slice(0, 10)
      this.currentPage = 1
      this.loading = false
    },
  },

  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
